export const GET_REQUEST_HELP_DROPDOWN_VALUES_API_REQUEST =
  'GET_REQUEST_HELP_DROPDOWN_VALUES_API_REQUEST';
export const GET_REQUEST_HELP_DROPDOWN_VALUES_API_ERROR =
  'GET_REQUEST_HELP_DROPDOWN_VALUES_API_ERROR';
export const GET_REQUEST_HELP_DROPDOWN_VALUES_API_SUCCESS =
  'GET_REQUEST_HELP_DROPDOWN_VALUES_API_SUCCESS';
export const GET_QNR_VALUES_API_REQUEST = 'GET_QNR_VALUES_API_REQUEST';
export const GET_QNR_VALUES_API_ERROR = 'GET_QNR_VALUES_API_ERROR';
export const GET_QNR_VALUES_API_SUCCESS = 'GET_QNR_VALUES_API_SUCCESS';
